// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kq-0";